var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApache(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 102,
    viewBox: "0 0 80 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9825 5.59911C48.0482 7.13603 46.3311 8.95311 44.8825 10.9961L46.8825 14.9599C48.1799 12.9822 49.6066 11.1017 51.1525 9.33186C51.2625 9.20324 51.3225 9.14286 51.3225 9.14286L51.1525 9.33186C49.684 11.1255 48.3469 13.0332 47.1525 15.0386C49.76 14.8438 52.356 14.5065 54.93 14.028C55.2217 12.936 55.3057 11.7944 55.177 10.6684C55.0483 9.54233 54.7095 8.45397 54.18 7.46548C54.18 7.46548 52.25 4.19998 49.9825 5.59911Z",
    fill: "url(#paint0_linear_112_15)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2625 38.8973L42.475 39.0417L42.8775 38.976C43 38.9524 43.1325 38.9262 43.2625 38.8973Z",
    fill: "#BE202E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M43.2625 38.8973L42.475 39.0417L42.8775 38.976C43 38.9524 43.1325 38.9262 43.2625 38.8973Z",
    fill: "#BE202E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9325 35.4375L44.0575 35.4191C44.2275 35.3929 44.395 35.3614 44.5575 35.3246L43.9375 35.4349L43.9325 35.4375Z",
    fill: "#BE202E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M43.9325 35.4375L44.0575 35.4191C44.2275 35.3929 44.395 35.3614 44.5575 35.3246L43.9375 35.4349L43.9325 35.4375Z",
    fill: "#BE202E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.985 25.2C41.5933 24.0065 42.2092 22.841 42.8325 21.7035C43.4792 20.524 44.1325 19.3821 44.7925 18.2778L44.9075 18.081C45.5608 16.996 46.2192 15.9538 46.8825 14.9546L44.8825 10.9908L44.4275 11.5815C43.85 12.3375 43.2525 13.1565 42.6375 14.0096C41.945 14.9808 41.2325 16.0151 40.51 17.1045C39.8425 18.1098 39.165 19.1625 38.4875 20.2545C37.91 21.1811 37.3325 22.1366 36.7575 23.1157L36.6925 23.226L39.295 28.6125C39.8517 27.4645 40.415 26.327 40.985 25.2Z",
    fill: "url(#paint1_linear_112_15)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1275 55.629C28.7825 56.623 28.4367 57.6371 28.09 58.6714L28.075 58.716L27.9275 59.1544C27.695 59.8526 27.49 60.4669 27.025 61.908C27.893 62.4982 28.5764 63.3435 28.99 64.3387C28.9336 63.1805 28.445 62.0922 27.63 61.3095C29.2697 61.5882 30.9507 61.3879 32.4892 60.7304C34.0277 60.073 35.3642 58.9838 36.3525 57.582C36.5064 57.3176 36.6442 57.0431 36.765 56.7604C36.3522 57.2964 35.8087 57.7047 35.1923 57.9418C34.5759 58.179 33.9098 58.2361 33.265 58.107C35.3885 57.284 37.1889 55.7391 38.38 53.718C38.6575 53.2507 38.925 52.7415 39.2 52.1771C38.2353 53.2898 37.0112 54.1194 35.6484 54.5843C34.2855 55.0492 32.8308 55.1333 31.4275 54.8284L29.3225 55.0699C29.25 55.2562 29.1925 55.4426 29.1275 55.629Z",
    fill: "url(#paint2_linear_112_15)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.11 50.6783C30.565 49.4428 31.0333 48.195 31.515 46.935C31.975 45.7275 32.4475 44.5139 32.9325 43.2941C33.4175 42.0744 33.9125 40.8494 34.4175 39.6191C34.9308 38.3749 35.455 37.1333 35.99 35.8943C36.525 34.6553 37.0625 33.4399 37.6025 32.2481C37.7992 31.8141 37.9975 31.381 38.1975 30.9488C38.5425 30.2033 38.89 29.4639 39.24 28.7306C39.2575 28.6913 39.2775 28.6519 39.2975 28.6125L36.6925 23.2234L36.565 23.4413C35.96 24.4913 35.355 25.5413 34.7625 26.6333C34.17 27.7253 33.575 28.8488 33.0125 29.9828C32.5275 30.94 32.0542 31.9025 31.5925 32.8703L31.3175 33.4609C30.75 34.6868 30.2375 35.8706 29.775 37.0099C29.25 38.2996 28.7867 39.5299 28.385 40.7006C28.1175 41.4698 27.885 42.2126 27.655 42.924C27.4725 43.533 27.3 44.142 27.135 44.7615C26.745 46.193 26.4117 47.6201 26.135 49.0429L28.75 54.4635C29.0967 53.494 29.4517 52.5105 29.815 51.513L30.11 50.6783Z",
    fill: "url(#paint3_linear_112_15)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0875 49.2319C25.759 50.9427 25.5319 52.6733 25.4075 54.4137C25.4075 54.474 25.4075 54.5344 25.395 54.5948C24.5691 53.5009 23.5506 52.5839 22.395 51.8937C23.9307 53.9486 24.9394 56.3823 25.325 58.9628C24.1906 59.0682 23.0495 58.8638 22.0125 58.3695C22.795 59.2096 23.7666 59.829 24.8375 60.1703C23.3735 60.4638 22.0146 61.1749 20.91 62.2257C22.3469 61.4645 23.9618 61.1529 25.5625 61.3279C23.775 66.6462 21.9825 72.5183 20.19 78.75C20.4387 78.6757 20.666 78.5378 20.8514 78.3486C21.0368 78.1594 21.1747 77.9248 21.2525 77.6659C21.5725 76.5372 23.6925 69.132 27.0175 59.3985L27.305 58.5638L27.385 58.3302C27.7367 57.3099 28.1008 56.2687 28.4775 55.2064L28.7275 54.4793V54.4662L26.125 49.0455C26.1125 49.1059 26.0975 49.1689 26.0875 49.2319Z",
    fill: "url(#paint4_linear_112_15)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7 29.0797L39.475 29.5654C39.25 30.0536 39.0217 30.5524 38.79 31.0616C38.54 31.6129 38.29 32.1772 38.04 32.7547C37.91 33.0461 37.79 33.3375 37.6525 33.6341C37.2625 34.5231 36.8675 35.441 36.4675 36.3877C35.9675 37.5532 35.4675 38.7642 34.9675 40.0207C34.4825 41.2195 33.9908 42.4602 33.4925 43.743C33.0192 44.968 32.54 46.2245 32.055 47.5125C31.6233 48.6692 31.1875 49.8566 30.7475 51.0746C30.725 51.135 30.705 51.1927 30.685 51.2531C30.2483 52.4659 29.8075 53.7101 29.3625 54.9859L29.3325 55.0725L31.4375 54.831L31.3125 54.8074C34.395 54.1489 37.2023 52.4895 39.3375 50.064C40.401 48.8488 41.324 47.506 42.0875 46.0635C42.7511 44.8194 43.3405 43.5333 43.8525 42.2126C44.34 40.9736 44.8075 39.6349 45.2575 38.1806C44.6353 38.5139 43.9724 38.7559 43.2875 38.8999C43.16 38.9287 43.0375 38.955 42.8975 38.9786C42.7575 39.0022 42.63 39.0259 42.495 39.0442C44.6864 38.0986 46.4442 36.299 47.4 34.0226C46.5432 34.636 45.5853 35.0766 44.575 35.322C44.41 35.3614 44.245 35.3902 44.075 35.4165L43.95 35.4349C44.6957 35.1188 45.4005 34.7052 46.0475 34.2037C46.175 34.104 46.2975 33.999 46.4175 33.8887C46.6 33.7234 46.7725 33.5501 46.9375 33.3637C47.0425 33.2482 47.145 33.1275 47.245 33.0015C47.4846 32.7009 47.7042 32.3834 47.9025 32.0512C47.965 31.9462 48.0275 31.8412 48.0875 31.731C48.165 31.5735 48.24 31.4186 48.3125 31.2637C48.64 30.5707 48.9025 29.9512 49.11 29.4105C49.215 29.148 49.305 28.8855 49.3825 28.6545C49.415 28.5626 49.445 28.4707 49.4725 28.392C49.555 28.1295 49.6225 27.9011 49.675 27.6964C49.739 27.4589 49.7908 27.2179 49.83 26.9745C49.7433 27.0463 49.6523 27.1121 49.5575 27.1714C48.647 27.6778 47.6669 28.032 46.6525 28.2214L48.585 27.9982L46.6525 28.2214H46.6075L46.31 28.2712L46.3625 28.2476L39.75 29.0089L39.7 29.0797Z",
    fill: "url(#paint5_linear_112_15)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.145 15.0413C46.5575 15.9889 45.915 17.0651 45.225 18.2858L45.115 18.48C44.5183 19.53 43.8858 20.6911 43.2175 21.9634C42.6408 23.0589 42.0417 24.2375 41.42 25.4993C40.8767 26.6 40.3167 27.769 39.74 29.0063L46.3525 28.245C47.8123 27.6401 49.0715 26.5999 49.975 25.2525C50.1975 24.9165 50.42 24.5648 50.6425 24.2025C51.3225 23.0895 51.9875 21.8636 52.5825 20.6456C53.1267 19.5401 53.6173 18.4064 54.0525 17.2489C54.2782 16.6479 54.4726 16.0345 54.635 15.4114C54.755 14.9284 54.85 14.4716 54.9225 14.0359C52.3483 14.5124 49.7523 14.848 47.145 15.0413Z",
    fill: "url(#paint6_linear_112_15)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8725 38.976C42.74 38.9996 42.605 39.0233 42.47 39.0416C42.605 39.0233 42.75 38.9996 42.8725 38.976Z",
    fill: "#BE202E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M42.8725 38.976C42.74 38.9996 42.605 39.0233 42.47 39.0416C42.605 39.0233 42.75 38.9996 42.8725 38.976Z",
    fill: "#BE202E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8725 38.976C42.74 38.9996 42.605 39.0233 42.47 39.0416C42.605 39.0233 42.75 38.9996 42.8725 38.976Z",
    fill: "url(#paint7_linear_112_15)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M43.925 35.4375L44.05 35.4191L43.925 35.4375Z",
    fill: "#BE202E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M43.925 35.4375L44.05 35.4191L43.925 35.4375Z",
    fill: "#BE202E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M43.925 35.4375L44.05 35.4191L43.925 35.4375Z",
    fill: "url(#paint8_linear_112_15)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_112_15",
    x1: 41.5509,
    y1: 6.26336,
    x2: 56.3048,
    y2: 2.36295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69923"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "#F79A23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838,
    stopColor: "#E97826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_112_15",
    x1: 9.44049,
    y1: 75.3073,
    x2: 41.7436,
    y2: 9.41379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#C92037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#CD2335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E97826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_112_15",
    x1: 19.4545,
    y1: 70.3505,
    x2: 38.7036,
    y2: 31.0853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282662"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.095,
    stopColor: "#662E8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    stopColor: "#9F2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949,
    stopColor: "#CD2032"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_112_15",
    x1: -74083.6,
    y1: 24056.8,
    x2: -73712.2,
    y2: 24056.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#C92037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#CD2335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E97826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_112_15",
    x1: -48031.5,
    y1: 22889.8,
    x2: -47904.9,
    y2: 22889.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282662"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.095,
    stopColor: "#662E8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    stopColor: "#9F2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949,
    stopColor: "#CD2032"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_112_15",
    x1: -115379,
    y1: 21561.1,
    x2: -114801,
    y2: 21561.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#C92037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#CD2335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E97826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_112_15",
    x1: -85469.9,
    y1: 11489.4,
    x2: -85041.5,
    y2: 11489.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#C92037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#CD2335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E97826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_112_15",
    x1: -2223.75,
    y1: 89.216,
    x2: -2212.4,
    y2: 89.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#C92037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#CD2335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E97826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_112_15",
    x1: -659.892,
    y1: 49.4878,
    x2: -656.365,
    y2: 49.4878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#C92037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#CD2335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E97826"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApache);
export default __webpack_public_path__ + "static/media/apache.a94a957d8073930c9d92be2f79d3465f.svg";
export { ForwardRef as ReactComponent };